module.exports = __webpack_public_path__ + "img/logo.bf47667d.png";